import React from "react";
const SettingsPage = () => {
  return (
    <div className="Content SettingsPage">
      <div className="ContentHeader">
        <div className="HeaderTitle">
          Settings
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
